// Deutsche Texte — die Anrede ist durchgehend das höfliche „Sie“.
// Zwei Pluralformen (one | other), die vue-i18n von Haus aus wählt.
export default {
    general: {
        back:     'Zurück',
        next:     'Weiter',
        cancel:   'Abbrechen',
        from:     'ab',
        night:    'pro Nacht',
        nights:   '{count} Nacht | {count} Nächte',
        loading:  'Wird geladen …',
        language: 'Sprache',
        theme:    'Darstellung',
    },
    errors: {
        generic_error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
        invalid_data:  'Diese Angaben stimmen nicht.',
        not_found:     'Nicht gefunden.',
        offline:       'Wir erreichen das Hotel nicht. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
        no_house:      'Dieses Haus nimmt derzeit keine Online-Buchungen an.',
        taken:         'Dieses Zimmer wurde soeben von jemand anderem gebucht. Bitte wählen Sie ein anderes Zimmer oder einen anderen Zeitraum.',
        too_many:      'Zu viele Versuche. Bitte warten Sie einen Augenblick und versuchen Sie es erneut.',
        too_many_guests: 'In diesem Zimmer ist für so viele Personen kein Platz.',
        booking_failed:  'Die Buchung konnte nicht vorgenommen werden.',
        offer_gone:      'Das Angebot gilt nicht mehr. Angezeigt werden die regulären Preise des Hauses.',
    },
    step: {
        dates:   'Zeitraum',
        rooms:   'Zimmer',
        guest:   'Daten',
        summary: 'Übersicht',
        done:    'Bestätigt',
    },
    search: {
        title:          'Zimmer buchen',
        lead:           'Wählen Sie Ihren Zeitraum und die Anzahl der Personen; wir zeigen Ihnen die freien Zimmer und den Preis.',
        arrival:        'Anreise',
        departure:      'Abreise',
        adults:         'Erwachsene',
        children:       'Kinder',
        submit:         'Freie Zimmer suchen',
        stay_too_long:  'Ein Aufenthalt darf höchstens {nights} Nächte dauern.',
        departure_after: 'Die Abreise muss nach der Anreise liegen.',
        arrival_past:   'Die Anreise kann nicht in der Vergangenheit liegen.',
    },
    package: {
        title: 'Im Paket enthalten',
        included: 'inbegriffen',
        surcharges_total: 'Zuschläge',
        kind_room_service: 'Zimmerservice',
        kind_dining: 'Mahlzeit',
        kind_facility: 'Einrichtung',
        kind_parking: 'Parkplatz',
        kind_service: 'Leistung',
        kind_product: 'Produkt',
        when_arrival: 'bei der Anreise',
        when_each_night: 'jede Nacht',
        when_departure: 'bei der Abreise',
    },
    rooms: {
        component_gone: 'Ein Teil des Pakets ist für diese Daten nicht verfügbar',
        component_gone_hint: 'Ausgebucht: {what}. Versuchen Sie andere Daten — das Paket selbst gilt weiterhin.',
        title:      'Freie Zimmer',
        stay:       '{arrival} – {departure} · {nights} · {guests}',
        none:       'Für diesen Zeitraum ist kein Zimmer frei.',
        none_hint:  'Versuchen Sie es mit einem anderen Zeitraum oder mit weniger Personen.',
        change:     'Zeitraum ändern',
        choose:     'Auswählen',
        per_stay:   'für den gesamten Aufenthalt',
        left:       'Noch {count} Zimmer frei | Noch {count} Zimmer frei',
        sleeps:     'Für bis zu {count} Person | Für bis zu {count} Personen',
        beds:       '{count} Bett | {count} Betten',
        photo_of:   'Foto des Zimmers {name}',
        offer_price: 'Angebotspreis (−{percent} %)',
        early_booking:       'Frühbucher −{percent} %',
        early_booking_saved: 'Sie sparen {amount}',
        offer_applied: 'Die Preise unten entsprechen diesem Angebot, um {percent} % reduziert.',
        offer_gone: 'Das Angebot gilt nicht mehr',
        offer_gone_hint: 'Das Haus hat es zurückgezogen oder geändert, daher sehen Sie unten die regulären Preise.',
    },
    board: {
        none:       'Nur Übernachtung',
        breakfast:  'Übernachtung mit Frühstück',
        half_board: 'Halbpension',
        full_board: 'Vollpension',
        all_inclusive: 'All inclusive',
    },
    guest: {
        title:      'Ihre Daten',
        lead:       'Wir bestätigen Ihre Buchung an diese E-Mail-Adresse.',
        first_name: 'Vorname',
        last_name:  'Nachname',
        email:      'E-Mail-Adresse',
        phone:      'Telefon',
        notes:      'Nachricht an das Hotel',
        notes_hint: 'Optional — zum Beispiel Ihre Ankunftszeit oder ein besonderer Wunsch.',
        required:   'Dieses Feld ist erforderlich.',
        email_bad:  'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        submit:     'Weiter zur Übersicht',
    },
    summary: {
        room_only: 'Unterkunft',
        payment_optional: 'Sie können jetzt mit Karte zahlen oder bei der Anreise an der Rezeption.',
        payment_deposit: 'Eine Anzahlung von {amount} ({percent} % des Gesamtbetrags) bestätigt Ihre Buchung — jetzt oder über den Link in der E-Mail. Den Restbetrag begleichen Sie bei der Anreise an der Rezeption.',
        payment_full: 'Der Gesamtbetrag von {amount} bestätigt Ihre Buchung — jetzt oder über den Link in der E-Mail.',
        title:     'Übersicht',
        lead:      'Prüfen Sie Ihre Angaben und bestätigen Sie die Buchung.',
        stay:      'Aufenthalt',
        room:      'Zimmer',
        offer:     'Angebot',
        early_booking: 'Frühbucher',
        guests:    'Personen',
        contact:   'Kontakt',
        city_tax:  'Kurtaxe {amount} pro Person und Nacht',
        total:     'Gesamt inkl. MwSt.',
        payment:   'Zahlung bei der Anreise an der Rezeption.',
        cancellation: 'Kostenlose Stornierung bis {date}',
        terms:     'Allgemeine Geschäftsbedingungen',
        accept:    'Ich akzeptiere die Buchungs- und Stornierungsbedingungen.',
        accept_required: 'Für die Buchung müssen die Bedingungen akzeptiert werden.',
        submit:    'Buchung bestätigen',
        sending:   'Wird gesendet …',
    },
    done: {
        payment_optional: 'Sie können jetzt mit Karte zahlen oder bei der Anreise an der Rezeption.',
        payment_remainder: 'Den Restbetrag von {amount} begleichen Sie bei der Anreise an der Rezeption.',
        payment_required: 'Bitte zahlen Sie {amount}, um Ihren Aufenthalt abzuschließen',
        payment_required_hint: 'Das Zimmer ist gebucht und wartet auf Sie. Sie können jetzt zahlen oder später über den Link in Ihrer Bestätigungs-E-Mail.',
        payment_done: 'Zahlung erhalten. Vielen Dank!',
        pay_now: '{amount} zahlen',
        pay_later: 'Den Zahlungslink finden Sie auch in Ihrer Bestätigungs-E-Mail.',
        pay_failed: 'Die Zahlungsseite konnte nicht geöffnet werden. Bitte versuchen Sie es erneut oder nutzen Sie den Link in Ihrer E-Mail.',
        title:      'Ihre Buchung ist bestätigt',
        number:     'Buchungsnummer',
        keep:       'Bewahren Sie die Nummer auf — damit finden wir Sie, wenn Sie anrufen.',
        mail_sent:  'Die Bestätigung haben wir an {email} gesendet.',
        mail_none:  'Die Bestätigung konnte nicht per E-Mail versendet werden; das Hotel meldet sich bei Ihnen.',
        payment:    'Zahlung bei der Anreise an der Rezeption.',
        again:      'Neue Buchung',
    },
    occupancy: {
        adults:   '{count} Erwachsener | {count} Erwachsene',
        children: '{count} Kind | {count} Kinder',
    },
    license: {
        title: 'Dieser Service ist nicht aktiviert',
        lead: 'Dieses Hotel bietet keine Online-Buchung an, daher kann über diese Seite kein Zimmer reserviert werden.',
        contact: 'Bitte rufen Sie die Rezeption des Hotels an — man nimmt Ihre Buchung dort gerne entgegen.',
    },
    closed: {
        title: 'Buchungen sind derzeit nicht möglich',
        lead:  'Dieses Haus verkauft seine Zimmer derzeit nicht über das Internet. Rufen Sie bitte die Rezeption an — man hilft Ihnen dort gerne weiter.',
    },
}
